<div fxAlign="row" *ngIf="data">
  <div fxFlex>
    {{data?.message?.title}}
  </div>
  <div fxFlex fxLayoutAlign="end center">
    <button kendoButton [primary]="true" (click)="joinCall($event)">Join</button>
  </div>
</div>
